import { TextMatchTransformer } from '@lexical/markdown';
import { $createLineBreakNode, $isLineBreakNode, LineBreakNode, LexicalNode } from 'lexical';

export const BR: TextMatchTransformer = {
  type: 'text-match',
  dependencies: [LineBreakNode],

  regExp: /<br\s*\/?>/i,
  importRegExp: /<br\s*\/?>/i,

  export: (node: LexicalNode) => {
    if (!$isLineBreakNode(node)) {
      return null;
    }
    return '<br/>';
  },

  replace: node => {
    const lineBreak = $createLineBreakNode();
    node.replace(lineBreak);
    lineBreak.selectNext();
  },
};
